import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { css } from '@emotion/react';
import { Controller, useFormContext } from 'react-hook-form';
import { WarrantSettlementType } from '../../../../../data-models/scenario.data-model';
import { Label } from '../../../../../components/Form/FormComponents';

const fullWidthColumn = css`
  grid-column: 1 / -1;
`;

export function WarrantSettlementToggle({ index }: { index: number }) {
  const { control } = useFormContext();

  return (
    <Stack css={fullWidthColumn}>
      <Label>Warrant Exercise at Exit</Label>
      <Controller
        control={control}
        name={`scenarioTransactions.${index}.warrantSettlementType` as const}
        render={({ field: { onChange, value } }) => (
          <ToggleButtonGroup
            color='secondary'
            exclusive
            aria-label='warrant settlement type'
            value={value ?? WarrantSettlementType.cashless}
            onChange={(event, newValue) => {
              if (newValue) {
                onChange(newValue);
              }
            }}
          >
            <ToggleButton value={WarrantSettlementType.cashless}>Cashless</ToggleButton>
            <ToggleButton value={WarrantSettlementType.cash}>Cash Settlement</ToggleButton>
          </ToggleButtonGroup>
        )}
      />
    </Stack>
  );
}
